var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.66669 4.95833H11.8646C13.3569 4.95833 14.1029 4.95833 14.6389 5.31646C14.871 5.4715 15.0702 5.67072 15.2252 5.90275C15.5689 6.41709 15.5828 7.12498 15.5834 8.5M1.41669 14.875V5.62719C1.41669 4.34053 1.41669 3.69719 1.68608 3.21446C1.87811 2.87036 2.16204 2.58642 2.50615 2.39439C2.98888 2.125 3.63221 2.125 4.91888 2.125C5.7432 2.125 6.15537 2.125 6.51616 2.2603C7.33991 2.56921 7.67963 3.31754 8.05136 4.06097L8.50002 4.95833",
    stroke: "#111827",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5833 10.625H10.625M15.5833 12.75H10.625M12.3958 14.875H10.625",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.58415 14.1667C7.58415 14.1667 8.05108 11.2995 7.58415 10.8325C7.11721 10.3656 4.25002 10.8325 4.25002 10.8325M3.54169 14.875L7.08335 11.3333",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsIcon);
export default __webpack_public_path__ + "static/media/details-icon.cea4d9e43362d5c1e93f39789daa246b.svg";
export { ForwardRef as ReactComponent };